export const LOAD_PROFILE_DATA = 'profile/LOAD_PROFILE_DATA';
export const SET_PROFILE_STATUS = 'profile/SET_PROFILE_STATUS';
export const SET_PROFILE_DATA = 'profile/SET_PROFILE_DATA';
export const SET_ORDER_DATA = 'profile/SET_ORDER_DATA';
export const START_EDIT_PROFILE = 'profile/START_EDIT_PROFILE';
export const START_CHANGE_PASSWORD = 'profile/START_CHANGE_PASSWORD';
export const SET_CHANGE_PASSWORD_STATUS = 'profile/SET_CHANGE_PASSWORD_STATUS';
